module.exports = __webpack_public_path__ + "static/media/camion-marker.2a1a0519.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/common/img/camion-marker.svg
// module id = 206
// module chunks = 0